// extracted by mini-css-extract-plugin
export var dividerLine = "_4m-0";
export var errorBackground = "_4m-1";